<!--
 * @Description: 实际客户统计
 * @Author: cts
 * @Date: 2024-07-16
-->
<template>
  <el-card class="box query">
    <el-tabs v-model="activeTab" @tab-change="onTabChange">
      <el-tab-pane label="今日" name="today"></el-tab-pane>
      <el-tab-pane label="本月" name="month"></el-tab-pane>
    </el-tabs>

    <el-form :model="query" ref="query" :inline="true">
      <el-form-item label="报备日期">
        <el-date-picker
          v-model="query.dates"
          type="daterange"
          value-format="YYYY-MM-DD"
          unlink-panels
          :clearable="false"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          round
          @click="onSearch"
          icon="search"
          >查询</el-button
        >

        <el-tooltip
          class="box-item"
          effect="dark"
          content="下载查询结果数据"
          placement="top"
        >
          <el-button
            icon="Download"
            v-power="'admin/v1/reportanalysis/actual_customer/export_excel'"
            @click="downloadExcel"
            :loading="downloading"
            >下载数据</el-button
          >
        </el-tooltip>
      </el-form-item>
    </el-form>
  </el-card>

  <el-card class="box data" v-loading="loading">
    <div class="total-info" style="margin-bottom: 15px; font-size: 14px; color: #606266;">
      实际报备客户总数：<span style="font-weight: bold; color: #409EFF;">{{ tableData.counts }}</span>
    </div>

    <el-table :data="tableData.data" border stripe>
      <el-table-column label="客户姓名" prop="clientName" min-width="150"></el-table-column>
      <el-table-column label="客户手机" prop="clientMobile" width="150"></el-table-column>
      <el-table-column label="报备数量" prop="reportCount" width="120" sortable></el-table-column>
    </el-table>

    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageCurrentChange"
      :current-page="query.pageIndex"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="tableData.counts"
    ></el-pagination>
  </el-card>
</template>

<script>
import fileDownload from "js-file-download";

export default {
  data() {
    return {
      loading: false,
      downloading: false,
      activeTab: "today",
      query: {
        pageIndex: 1,
        pageSize: 20,
        sort: {
          order: "",
          prop: "",
        },
        dates: [],
      },
      tableData: {
        counts: 0,
        data: [],
      },
    };
  },
  created() {
    this.setTodayDates();
    this.loadData();
  },
  methods: {
    /**
     * 设置今日日期范围
     */
    setTodayDates() {
      var today = this.$moment().format("YYYY-MM-DD");
      this.query.dates = [today, today];
    },

    /**
     * 设置本月日期范围
     */
    setMonthDates() {
      var startMonth = this.$moment().startOf("month").format("YYYY-MM-DD");
      var endMonth = this.$moment().endOf("month").format("YYYY-MM-DD");
      this.query.dates = [startMonth, endMonth];
    },

    /**
     * Tab 切换
     */
    onTabChange(name) {
      if (name === "today") {
        this.setTodayDates();
      } else if (name === "month") {
        this.setMonthDates();
      }
      this.onSearch();
    },

    /**
     * 搜索
     */
    onSearch() {
      this.query.pageIndex = 1;
      this.loadData();
    },

    /**
     * 分页页数更改
     */
    pageSizeChange(val) {
      this.query.pageSize = val;
      this.loadData();
    },

    /**
     * 分页页码更改
     */
    pageCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },

    /**
     * 加载数据
     */
    loadData() {
      this.loading = true;
      this.$http
        .post("/admin/v1/reportAnalysis/actual_customer", this.query)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data;
          }
        })
        .finally(() => (this.loading = false));
    },

    /**
     * 下载数据
     */
    downloadExcel() {
      this.downloading = true;
      var arg = Object.assign({}, this.query);
      this.$http
        .post("admin/v1/reportAnalysis/actual_customer/export_excel", arg, {
          responseType: "blob",
        })
        .then((res) => {
          fileDownload(res, "实际客户统计.xlsx");
        })
        .finally(() => {
          this.downloading = false;
        });
    },
  },
};
</script>

<style scoped>
.total-info {
  padding: 10px 0;
}
</style>
